import React from 'react';

export const YoutubeIcon = React.memo(({ size = 50 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill="#FF0000" />
    <polygon points="26,24 26,40 42,32" fill="#fff" />
  </svg>
));

export const FacebookIcon = React.memo(({ size = 50 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill="#1877F2" />
    <path d="M36 22h6v-8h-6c-5.523 0-10 4.477-10 10v6h-6v8h6v14h8V38h6l2-8h-8v-6c0-1.105.895-2 2-2Z" fill="#fff" />
  </svg>
));

export const InstagramIcon = React.memo(({ size = 50 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <radialGradient id="igCircle" cx="30%" cy="30%" r="80%">
        <stop offset="0%" stopColor="#feda75"/>
        <stop offset="50%" stopColor="#d62976"/>
        <stop offset="100%" stopColor="#4f5bd5"/>
      </radialGradient>
    </defs>
    <circle cx="32" cy="32" r="30" fill="url(#igCircle)" />
    <rect x="20" y="20" width="24" height="24" rx="7" fill="none" stroke="#fff" strokeWidth="4" />
    <circle cx="32" cy="32" r="6" fill="none" stroke="#fff" strokeWidth="4" />
    <circle cx="41" cy="23" r="3" fill="#fff" />
  </svg>
));

export const TiktokIcon = React.memo(({ size = 50 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill="#000" />
    <path d="M40 18c2.2 3.5 5.8 5.9 10 6.5v6.8c-4.7-.3-8.7-2.2-10-4.2v16.3c0 6.3-5.1 10.6-11.8 10.6S16.5 50.1 16.5 43.8c0-7.2 6.9-12 13.5-10.3v5.8c-1.7-.8-4-.6-5.6.5-1.8 1.2-2.7 3-2.7 4.9 0 3.2 2.6 5.4 5.9 5.4 3.3 0 5.9-2.4 5.9-6V18h6Z" fill="#25F4EE"/>
    <path d="M50 30.5v-6.8c-4.2-.6-7.8-3-10-6.5h-6v23.2c0 3.6-2.6 6-5.9 6-3.3 0-5.9-2.2-5.9-5.4 0-1.9.9-3.7 2.7-4.9 1.6-1.1 3.9-1.3 5.6-.5v-5.8c-6.6-1.7-13.5 3.1-13.5 10.3 0 6.3 5.1 10.6 11.8 10.6S40 49 40 42.7V25.3c1.3 2 5.3 3.9 10 4.2Z" fill="#FE2C55" opacity=".9" />
  </svg>
));


